import { render, staticRenderFns } from "./PrintableResidentReport360.vue?vue&type=template&id=3310c027&scoped=true"
import script from "./PrintableResidentReport360.ts?vue&type=script&lang=ts&external"
export * from "./PrintableResidentReport360.ts?vue&type=script&lang=ts&external"
import style0 from "./PrintableResidentReport360.scss?vue&type=style&index=0&id=3310c027&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3310c027",
  null
  
)

export default component.exports